import { request } from "#/utils/request";

interface IGetVendasEmitirRegulamento {
  idProduto: number;
  codigoComissionado: string;
}

export interface IGetVendasEmitirRegulamentoData {
  data: Data;
  errors: Errors;
}

interface Data {
  regulation: string;
}

interface Errors {
  message: string;
  code: number;
}

export const getVendasEmitirRegulamento = async ({
  idProduto,
  codigoComissionado,
}: IGetVendasEmitirRegulamento) => {
  return (
    await request.get<IGetVendasEmitirRegulamentoData>(
      `/vendas/emitir-regulamento?idProduto=${idProduto}&codigoComissionado=${codigoComissionado}`
    )
  ).data;
};
